import { CognitoAuth } from "amazon-cognito-auth-js";

const CLIENT_ID = "5kg28tao3betj8m7r3sd85s48g";
const APP_DOMAIN = "fs-user.auth.eu-west-1.amazoncognito.com"
/*** Dev Env ***/
// const REDIRECT_URI = "http://localhost:8080/";
// const USERPOOL_ID = "/login";
// const REDIRECT_URI_SIGNOUT = "https://fs-user.auth.eu-west-1.amazoncognito.com/logout?response_type=token&client_id=5kg28tao3betj8m7r3sd85s48g&redirect_uri=http://localhost:8080&scope=email+openid+profile+aws.cognito.signin.user.admin";

/*** Prod Env ***/
const REDIRECT_URI = "https://manage.gecko-gw.dev.symbiotech.com.au/";
const USERPOOL_ID = "eu-west-1_kUkbAU9cT";
const REDIRECT_URI_SIGNOUT = "https://fs-user.auth.eu-west-1.amazoncognito.com/logout?response_type=token&client_id=5kg28tao3betj8m7r3sd85s48g&redirect_uri=https://manage.gecko-gw.dev.symbiotech.com.au/&scope=email+openid+profile+aws.cognito.signin.user.admin";
var authData = {
  ClientId: CLIENT_ID,
  AppWebDomain: APP_DOMAIN,
  TokenScopesArray: [
    "openid",
    "email",
    "profile",
    "aws.cognito.signin.user.admin"
  ],
  RedirectUriSignIn: REDIRECT_URI,
  RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
  UserPoolId: USERPOOL_ID
};

var auth = new CognitoAuth(authData);
auth.useCodeGrantFlow();

function getUserInfoStorageKey() {
  var keyPrefix = "CognitoIdentityServiceProvider." + auth.getClientId();
  var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
  var userInfoKey = keyPrefix + "." + tokenUserName + ".userInfo";
  return userInfoKey;
}

export default {
  auth: auth,
  login() {
    auth.getSession();
  },

  logout() {
    window.location.href = REDIRECT_URI_SIGNOUT;
  },
  getUserInfoStorageKey
};
